<template>

<!--
    Client Autocomplete Component

    @version 1.0
-->

<!-- rowkey="CustomerNumber" -->

<div class="input-group w-100 flex-nowrap border-0">

    <!-- client auto complete -->
    <kt-autocomplete
        class="flex-grow-1"
        inputclass="form-control rounded-end-0 form-control-sm"
        :options="list"
        rowvalue="Company"
        :rowkey="props.rowkey"
        :label="props.label"
        :placeholder="props.placeholder"
        @change="onChange"
        v-model="model"
        suffix-class="p-0"
        :disabled="props.disabled"
        :readonly="props.readonly"
        search-mode="startsWith"
    >
      
    <!-- drop down template -->
    <template #option="{ option }">
      <slot name="option" :option="option">
        <div class="dropdown-item autocomplete-option">
            {{ option.Company }}
        </div>
      </slot>
    </template>

    <template #suffix>
        <!-- edit client button -->
        <button 
            v-if="model && !props.disabled"
            @click="editClient(model)" 
            class="btn btn-sm btn-outline-secondary rounded-start-0 rounded-end-0"
        ><i class="fa fa-edit"></i>
        </button>

        <!-- new client button -->
        <button 
            v-if="!props.disabled"
            @click="editClient()"
            class="btn btn-sm btn-outline-primary rounded-start-0"
        ><i class="fa fa-plus"></i>
        </button>
    </template>

    </kt-autocomplete>

</div>

<kt-modal
    :title="formTitle"
    :visible="formVisible"
    @dismiss="formDismiss()"
>
    <template #body>
        <client-form
            v-model="form"
        ></client-form>
    </template>

    <template #footer>
        <div class="container-fluid px-0">
            <div class="row">
                <div class="col">
                    <button 
                        @click="formDismiss()" 
                        class="btn btn-sm btn-outline-secondary form-control"
                    >Close</button>
                </div>
                <!-- deletion button ...
                <div class="col-4" v-if="extraRecord.Id">
                    <button @click="extraDelete()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                -->
                <div class="col">
                    <button 
                        @click="formSave(form)" 
                        class="btn btn-sm btn-outline-primary form-control"
                    >Save</button>
                </div>
            </div>
        </div>
    </template>
</kt-modal>

</template>

<script setup>

import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useClientStore } from "@/stores/ClientStore";
import Api from "@/services/Api";
import KtAutocomplete from "@/components/UI/KtAutocomplete.vue";
import KtModal from "@/components/UI/KtModal.vue";
import ClientForm from "@/components/Clients/ClientForm.vue";

const formTitle = ref("Edit Client");
const formVisible = ref(false);
const form = ref({});

const props = defineProps(
{
    // sometimes we want the customer id ...
    rowkey: {
        type: String,
        default: "CustomerNumber"
    },

    label: {
        type: String,
        default: "Client"
    },

    inputClass: {
        type: String,
        default: ""
    },

    placeholder: {
        type: String,
        default: "Select a client"
    },

    disabled: {
        type: Boolean,
        default: false
    },

    readonly: {
        type: Boolean,
        default: false
    },
});

const model = defineModel({
    type: String,
    default: ""
});

const emits = defineEmits(["change"]);
const clientStore = useClientStore();
const { list } = storeToRefs(clientStore);

const onChange = (value) =>
{
    emits("change", value);
}

const editClient = async (val) =>
{
    // edit client ...
    if (val)
    {
        formTitle.value = "Edit Client";
        
        if (props.rowkey == "CustomerNumber")
        {
            let tmp = await clientStore.getByCustomerNumber(val);
            val = tmp.Id;
        }

        form.value = await Api.loadClient(val);
    }

    // new client ...
    else
    {
        formTitle.value = "New Client";
        form.value = {};
    }

    formVisible.value = 1;
};

const formDismiss = () =>
{
    formVisible.value = 0;
};

const formSave = async (rec) =>
{
    await Api.saveClient(rec);
    await clientStore.reload();

    formVisible.value = false;
};

onMounted(async () =>
{
    await clientStore.reload();
});

</script>